import { Moment } from 'moment';

import { HALF_AN_HOUR } from '@lumapps/constants';

export const getMatchingTime = (date: Moment, locale: string, method?: 'round' | 'ceil'): string => {
    let resDate;
    // we want to either round it up (= as soon as half an hour has started, return the next one), or "closer but down" (= before 30 is 0, after 30 is 30)
    switch (method) {
        // round up
        case 'ceil':
            // 14:00 must NOT be rounded to 14:30, so 0 minute returns 0
            if (date.minutes() === 0) {
                resDate = date.minutes(0);
            }
            // as soon as minutes are higher then 30, move to the next hour, so 09:31 returns 10:00, same for 09:59
            else if (date.minutes() > HALF_AN_HOUR) {
                resDate = date.minutes(0).hours(date.hours() + 1);
            }
            // in other cases (= minutes between 1 and 30), return 30.
            else {
                resDate = date.minutes(HALF_AN_HOUR);
            }
            break;
        // round "closer but down"
        case 'round':
        default:
            resDate = date.minutes() >= HALF_AN_HOUR ? date.minutes(HALF_AN_HOUR) : date.minutes(0);
    }

    return resDate.locale(locale).format('LT');
};
